import { render } from "./Xing.vue?vue&type=template&id=d384a5ca"
import script from "./Xing.vue?vue&type=script&lang=js"
export * from "./Xing.vue?vue&type=script&lang=js"
script.render = render

export default script